/** Sinal de menos tipográfico (U+2212), da mesma largura do "+". */
const MINUS = '−';

/** 20 → "20 pts". */
export const formatPoints = (points: number): string => `${points} pts`;

/**
 * Pontos de uma missão: "—" enquanto o juiz não respondeu, para não
 * confundir "sem resposta" com "zero".
 */
export const formatMissionPoints = (points?: number): string =>
  points === undefined ? '—' : formatPoints(points);

/**
 * Bônus e penalidade com sinal: "+20", "−15". Zero fica sem sinal, porque
 * "+0" e "−0" chamam atenção para algo que não aconteceu.
 */
export const formatSigned = (points: number, sign: '+' | '-'): string => {
  if (points === 0) return '0';
  return `${sign === '+' ? '+' : MINUS}${Math.abs(points)}`;
};
